import { useContext, useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { Alert, Button, Card, Col, Form, Image, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap"
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { Link, useHistory } from "react-router-dom"
import { Field, Formik } from "formik"
import Select from 'react-select'
import * as Yup from 'yup';
import Post from '../../../api/Post'
import Get from '../../../api/Get'
import { ACCOUNT_ADD, 
    ACCOUNT_GET,
    CURRENCY_LIST_ACTIVE,
    ESPECIALITIES_ALL,
    GET_PLANES,
    PARTNER_LIST_ACTIVE 
} from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import LoadingList from "../../../loader/LoadingList";
import useQuery from "../../../hook/useQuery";
import { withTranslation } from "react-i18next";
import ComponentModalErrorSever from "../../../components/ComponentModalErrorSever";
import { BsQuestionCircleFill } from "react-icons/bs";
import ComponentNewSpecilidad from "../../../components/catalogos/ComponentNewSpecilidad";
import { FaCopy, FaEdit } from "react-icons/fa";
import { IoCloseCircle } from "react-icons/io5";
import iconRecheck from '../../../img/icons/recheck.svg'
import { toast } from "react-toastify";
import { URL_PAGE } from "../../../constants/urls";

function AddCuenta({t}){
    const history = useHistory();
    const query = useQuery()
    const id = query.get('id')
    const [loading, setLoading] = useState(false)
    const [partnersItems, setPartnersItems] = useState([])
    const [partnerDefault, setPartnerDefault] = useState()
    const [specialtyDurationList, setSpecialtyDurationList] = useState([])
    const [showModal, setShowModal] = useState(false);
    const [indexEdit, setIndexEdit] = useState(null)
    const [hasCopaymentParent, setHasCopaymentParent] = useState(false)
    const [initialValues, setInitialValues] = useState({
        id:null,
        name:'',
        clcuentaIke:'',
        automaticValidation: false,
        active:false,
        partner:'',
        helpCenter: '',
        allowRecord: true,
        specialtyDurationList: [],
        automaticPaid: false,
        hasCopayment: false
    })
    const [specialityOpt, setSpecialityOpt] = useState([])
    const [initEspecialidad, setInitEspecialidad] = useState(null)   
    const [account, setAccount] = useState(null)
    
    const shemaValidate = Yup.object().shape({
        name:Yup.string().required(t('Camporequerido')),
        partner:Yup.string().required(t('Camporequerido')),
    });
    const [errorSpeciality, setErrorSpeciality] = useState(false)

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }

    const handleClose = () => setShowModal(false);
    const handleShow = () => {
        setInitEspecialidad(null)
        setIndexEdit(null)
        setShowModal(true)
    }
    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => setShowSuccess(false);

    //Token de autentificación para los servicios
    const { auth } = useContext(authContext)
    let accesToken = auth?.data?.access_token;

    //Get Lista de Partners
    useEffect(() => {
        setLoading(true)
        Get({url: PARTNER_LIST_ACTIVE, access_token: accesToken})
        .then((resp) => {
            let items = []
            resp.data.data.response.forEach( partner => items.push({ value:partner?.id, label:partner?.name }) );
            setPartnersItems(items)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            } 
            setLoading(false)
        })

        Get({url: ESPECIALITIES_ALL, access_token: accesToken})
        .then( resp =>{
            setSpecialityOpt(resp.data.data.response.map(el=>({value: el.id, label: el.name})))
        }).catch( error => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            } 
        } )
    }, [])

    //Cargar la información de la cuenta
    useEffect(() => {
        if(id && partnersItems.length>0){
            setLoading(true)
            Get({url: `${ACCOUNT_GET}/${id}`, access_token: accesToken}).then((resp) => {
                const data = resp.data.data                
                //console.log(data)
                setInitialValues({
                    id: data.id,
                    name: data?.name,
                    clcuentaIke:data?.clcuentaIke ?? '',
                    automaticValidation: data?.automaticValidation,
                    active: data?.active,
                    partner: data?.partner?.id,
                    especialtyList: data.especialtyList,
                    helpCenter: data.helpCenter === null ? '' : data.helpCenter,
                    allowRecord: data?.allowRecord,
                    specialtyDurationList: data.specialtyDurationList,
                    automaticPaid: data.automaticPaid,
                    hasCopayment: data.hasCopayment
                })
                setHasCopaymentParent(data.hasCopayment)
                const partner = partnersItems.filter( item => item?.value == data?.partner?.id)
                setSpecialtyDurationList(data.specialtyDurationList)
                setPartnerDefault(partner[0])
                setAccount(data)
                setLoading(false)
            })
            .catch((error) => {
                setShowModalServer(true)
                if(error.response){
                    setErrorServer(error.response)
                } 
                setLoading(false)
            })
        }
    }, [ partnersItems ])

    const handleDelete = index =>{
        let newArr = specialtyDurationList.filter((item, i) => i!==index)
        setSpecialtyDurationList(newArr)
    }

    const handleEdit = index =>{
        let objSpecialidad = specialtyDurationList[index]
        setInitEspecialidad(objSpecialidad)
        setIndexEdit(index)
        setShowModal(true)
    }

    //get all the currencies and planes
    const [currenciesOpt, setCurrenciesOpt] = useState([])
    const [planesOpt, setPlanesOpt] = useState([])
    useEffect(() => {
        async function getCurrencyApi(){
            const response = await Get({url: CURRENCY_LIST_ACTIVE, access_token: auth.data.access_token})
            setCurrenciesOpt(response.data)
        } 
        getCurrencyApi();

        async function getPlanesApi(){
            const response = await Get({url: GET_PLANES, access_token: auth.data.access_token})
            setPlanesOpt(response.data.data.response)
        }
        getPlanesApi();
    }, [])

    const copyClipboad = async () =>{
        try {
            const r = await navigator.clipboard.writeText(`${URL_PAGE}/public/agendamiento/cuenta/${id}`)
            console.log(r)
            toast.success("Link copiado", {autoClose: 3000})    
        } catch (error) {
            toast.error('Ocurrió un error mientras se copiaba el link. Por favor revise los permisos del navegador', {autoClose: 10000})
        }        
    }

    return( <>
        { 
            loading ? <LoadingList texto='' /> : <>

            <div className="body">
                <Row className="align-items-center">
                    <Col xs="12" md="8">
                        <h2 className="mb-0 title-top">{`${id ? 'Editar ' :'Agregar '}cuenta` }</h2>
                    </Col>
                    <Col xs="12" md="4" className="text-right">
                        <IoIosCloseCircle className="cancel-btn" onClick={e=>history.goBack()}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Formik initialValues={ initialValues }
                            validationSchema={ shemaValidate }
                            onSubmit={(values, { setSubmitting, setFieldValue }) => { 
                                //console.log(values)
                                const data = JSON.parse( JSON.stringify( values ) )
                                data.partner = { id: parseInt(values?.partner) }
                                data.specialtyDurationList = specialtyDurationList
                                
                                if(specialtyDurationList.length === 0){
                                    setErrorSpeciality(true)
                                }else{
                                    setErrorSpeciality(false)
                                    console.log(data)
                                    Post({url: ACCOUNT_ADD, data: data, header:true, access_token:accesToken})
                                    .then((response) => {
                                        setSubmitting(false)  
                                        setShowSuccess(true)
                                        setTimeout(() => {
                                            setShowSuccess(false)
                                            history.goBack()
                                        }, 2000);
                                        
                                    })                
                                    .catch((error) => {
                                        setSubmitting(false)  
                                        setShowModalServer(true)
                                        if(error.response){
                                            setErrorServer(error.response)
                                        }                                     
                                    })
                                }
                            }}
                        >{({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                        }) => (
                            <Form onSubmit={handleSubmit}  className='mt-3'>
                                {isSubmitting && <LoadingList texto="Procesando información" />}
                                <Card className="shadow-1 formSection">
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Nombre de la cuenta</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.name && 'error'}`}
                                                        name="name"
                                                    />
                                                    { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Clave Ike</Form.Label>
                                                    <Field 
                                                        type="number"
                                                        className={`form-control input-form ${errors.clcuentaIke && 'error'}`}
                                                        name="clcuentaIke"
                                                    />
                                                    { errors.clcuentaIke && <div className="invalid-feedback d-block">{errors.clcuentaIke}</div> }
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Centro de ayuda</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.helpCenter && 'error'}`}
                                                        name="helpCenter"
                                                    />
                                                    { errors.helpCenter && <div className="invalid-feedback d-block">{errors.helpCenter}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Cliente Corporativo</Form.Label>
                                                    <Select 
                                                        name="partner"
                                                        options={ partnersItems } 
                                                        defaultValue={ partnerDefault }
                                                        onChange={ item => setFieldValue("partner", item?.value) }
                                                    />
                                                    { errors.partner && <div className="invalid-feedback d-block">{errors.partner}</div> }
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className='switch-container'>
                                                    <Form.Group>
                                                        <Form.Label className="font-weight-bold-600 text-secondary">Activo</Form.Label>
                                                        <br/>
                                                        <BootstrapSwitchButton
                                                            checked={ values?.active } 
                                                            onlabel="On"
                                                            onstyle="success"
                                                            offlabel="Off"
                                                            offstyle="danger"
                                                            width={ 69 }
                                                            size="md"
                                                            onChange={ value => setFieldValue("active", value) }
                                                        />
                                                        { errors.active && <div className="invalid-feedback d-block">{errors.active}</div> }
                                                    </Form.Group>
                                                </div>
                                                <div className='switch-container'>
                                                    <Form.Group>
                                                        <Form.Label className="font-weight-bold-600 text-secondary">Validación Automática</Form.Label>
                                                        <br/>
                                                        <BootstrapSwitchButton
                                                            checked={ values?.automaticValidation } 
                                                            onlabel="On"
                                                            onstyle="success"
                                                            offlabel="Off"
                                                            offstyle="danger"
                                                            width={ 69 }
                                                            size="md"
                                                            onChange={ value => setFieldValue("automaticValidation", value) }
                                                        />
                                                        { errors.clcuentaIke && <div className="invalid-feedback d-block">{errors.clcuentaIke}</div> }
                                                    </Form.Group>
                                                </div>
                                                <div className='switch-container'>
                                                    <Form.Group>
                                                        <Form.Label className="font-weight-bold-600 text-secondary">Grabación Automática</Form.Label>
                                                        <br/>
                                                        <BootstrapSwitchButton
                                                            checked={ values?.allowRecord } 
                                                            onlabel="On"
                                                            onstyle="success"
                                                            offlabel="Off"
                                                            offstyle="danger"
                                                            width={ 69 }
                                                            size="md"
                                                            onChange={ value => setFieldValue("allowRecord", value) }
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className='switch-container'>
                                                    <Form.Group>
                                                        <Form.Label className="font-weight-bold-600 text-secondary">Pago automático</Form.Label>
                                                        <br/>
                                                        <BootstrapSwitchButton
                                                            checked={ values?.automaticPaid } 
                                                            onlabel="On"
                                                            onstyle="success"
                                                            offlabel="Off"
                                                            offstyle="danger"
                                                            width={ 69 }
                                                            size="md"
                                                            onChange={ value => setFieldValue("automaticPaid", value) }
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className='switch-container'>
                                                    <Form.Group>
                                                        <Form.Label className="font-weight-bold-600 text-secondary">Tiene copago</Form.Label>
                                                        <br/>
                                                        <BootstrapSwitchButton
                                                            checked={ values?.hasCopayment } 
                                                            onlabel="On"
                                                            onstyle="success"
                                                            offlabel="Off"
                                                            offstyle="danger"
                                                            width={ 69 }
                                                            size="md"
                                                            onChange={ value => {
                                                                setFieldValue("hasCopayment", value)
                                                                setHasCopaymentParent(value)
                                                            } }
                                                        />
                                                        { errors.hasCopayment && <div className="invalid-feedback d-block">{errors.hasCopayment}</div> }
                                                    </Form.Group>
                                                </div>
                                            </Col>                                            
                                        </Row>
                                        {values.id &&
                                        <div className="d-flex">
                                            <div>
                                                <Form.Label className="font-weight-bold-600 text-secondary d-block">URL</Form.Label>
                                                <Alert variant="info">
                                                    <div className="d-flex">
                                                        <div className="pr-5">{`${URL_PAGE}/public/agendamiento/cuenta/${values.id}`}</div>
                                                        <div><FaCopy onClick={copyClipboad}/></div>
                                                    </div>
                                                </Alert>
                                            </div>
                                        </div>}
                                    </Card.Body>
                                </Card>
                                <Card className="shadow-1 mt-3"> 
                                    {errorSpeciality && <span className="d-block text-danger px-2">Debes seleccionar al menos 1 especialidad</span>}                                   
                                    <Card.Body>
                                        <div className="text-right mb-3">
                                            <Button variant="outline-info" type="button" size="sm" onClick={handleShow}>Nueva especialidad</Button>
                                        </div>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Especialidad</th>
                                                    <th>Duración</th>
                                                    <th>
                                                        <div>
                                                        <span>Tiempo espera 1</span>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id={`tooltip-top`}>
                                                                        Tiempo de espera para comenzar videoconferencia
                                                                    </Tooltip>
                                                                }
                                                                >
                                                                <BsQuestionCircleFill className="mb-1 ml-2"/>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div>
                                                            <span>Tiempo espera 2</span>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id={`tooltip-top`}>
                                                                        Tiempo de espera para esperar doctor
                                                                    </Tooltip>
                                                                }
                                                                >
                                                                <BsQuestionCircleFill className="mb-1 ml-2"/>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        Copago
                                                    </th>
                                                    <th>
                                                        Detalle
                                                    </th>
                                                    <th><span className="d-none">Acc</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    specialtyDurationList.length === 0 ?
                                                    <tr><td colSpan="4">No existen valores</td></tr> :
                                                    specialtyDurationList.map((item,i)=>(
                                                        <tr key={i}>
                                                            <td>{item.especialty.name}</td>
                                                            <td>{item.duration}</td>
                                                            <td>{item.firstWait}</td>
                                                            <td>{item.secondWait}</td>
                                                            <td>
                                                                <span className={`badge ${item.hasCopayment ? 'badge-success' : 'badge-danger'}`}>
                                                                {item.hasCopayment ? 'Si' : 'No'}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {
                                                                    item.hasCopayment ?
                                                                    <span>{`${item.plan?.name ?? 'Sin plan'} - ${item.amountPayment} ${item.currency?.code}`}</span> :
                                                                    'N/A'
                                                                }
                                                            </td>
                                                            <td>
                                                                <span 
                                                                    className="cursor-pointer text-info mr-3"
                                                                    onClick={e=>handleEdit(i)}
                                                                ><FaEdit /></span>
                                                                <span 
                                                                    className="cursor-pointer text-danger"
                                                                    onClick={e=>handleDelete(i)}
                                                                ><IoCloseCircle /></span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>

                                <Row className="grupoBotones">
                                <Col className="text-right">
                                    <Link to="/admin/cuentas" className="btn btn-danger cancelar-buttom">Cancelar</Link>{' '}
                                    <Button variant="outline-success" className="ok-buttom" type="submit">{`${id ? 'Editar' : 'Agregar'}`}</Button>{' '}
                                </Col>
                            </Row>
                            </Form>
                        )}</Formik>
                    </Col>
                </Row>
            </div></>
        }

        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />

        <ComponentNewSpecilidad 
            showModal={showModal} 
            setShowModal={setShowModal}
            specialityOpt={specialityOpt} 
            handleClose={handleClose}
            setSpecialtyDurationList={setSpecialtyDurationList}
            specialtyDurationList={specialtyDurationList}
            initEspecialidad={initEspecialidad}
            indexEdit={indexEdit}
            currenciesOpt={currenciesOpt}
            planesOpt={planesOpt}
            hasCopaymentParent={hasCopaymentParent}
        />

        <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
            <Modal.Body className="p-0">
                <div className="text-center position-relative overflow-hidden h-100p">
                    <Image src={iconRecheck} fluid className="img-recheck"/>
                    <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                </div>                
            </Modal.Body>
        </Modal>
    </> )
}

export default withTranslation()(AddCuenta)